import { render, staticRenderFns } from "./FormDirectorio.vue?vue&type=template&id=53c61ee0&scoped=true"
import script from "./FormDirectorio.vue?vue&type=script&lang=js"
export * from "./FormDirectorio.vue?vue&type=script&lang=js"
import style0 from "./FormDirectorio.vue?vue&type=style&index=0&id=53c61ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c61ee0",
  null
  
)

export default component.exports